import { ApolloProvider } from "@apollo/client/react";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
// Temporarily add @mui/material styling to use X Data Grid until it's available for Joy UI.
import {
  ThemeProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from "@mui/material/styles";
import { RequiredAuthProvider, RedirectToLogin, withAuthInfo, WithAuthInfoProps } from "@propelauth/react";
import { usePostHog } from "@posthog/react";
import { apolloClient, setToken } from "./graphql/apolloClient";
import { Loader } from "./components/loader";
import { NavBar } from "./components/navbar";
import { Pages } from "./pages";
import { joyTheme, materialTheme } from "./theme";
import { config } from "./util/common";

export default function Root() {
  const posthog = usePostHog();
  const App = withAuthInfo((props: WithAuthInfoProps) => {
    const { accessToken, isLoggedIn, user } = props;
    if (isLoggedIn) {
      setToken(accessToken);
      posthog.identify(user.userId, { 
        email: user.email, 
        name: user.username 
      });
      return (props as any).children;
    }
  });
  
  return (
    <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
      <CssVarsProvider defaultMode="light" theme={joyTheme} >
        <CssBaseline>
          <RequiredAuthProvider
            authUrl={config.REACT_APP_PROPELAUTH_URL as string}
            displayWhileLoading={<Loader />}
            displayIfLoggedOut={<RedirectToLogin postLoginRedirectUrl={window.location.href} />}
          >
            <ApolloProvider client={apolloClient}>
              <App>
                <NavBar />
                <Pages />
              </App>
            </ApolloProvider>
          </RequiredAuthProvider> 
        </CssBaseline>
      </CssVarsProvider>
    </MaterialCssVarsProvider>
  );
}
